import {runElectronFunc} from "./comm";

const openAlarmWidget = (props) => {
    runElectronFunc('ElectronAlarmWidgetApi', 'openAlarmWidget', props);
}

const updateAlarm = (props) => {
    runElectronFunc('ElectronAlarmWidgetApi', 'updateAlarm', props);
}

const flashAlarmWidget = (code) => {
    runElectronFunc('ElectronAlarmWidgetApi', 'flashAlarmWidget', code);
}
export {
    openAlarmWidget,
    updateAlarm,
    flashAlarmWidget,
};
